import { GLOBAL_CLIENT } from '../../helpers/GlobalClient'
import i18n from '../../helpers/i18n'

export const adminMeta = [
   {
      label: i18n.t(GLOBAL_CLIENT.mAccount),
      path: '/m-account'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.mTag),
      path: '/m-tags'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.products),
      path: '/m-products'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.productsGroup),
      path: '/list-products-group'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.order),
      path: '/m-order'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.order_scan),
      path: '/m-order-scan'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.warehouse),
      path: '/m-warehouse'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.mFund),
      path: '/m-fund'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.mPrice),
      path: '/m-price'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.mConfig),
      path: '/m-config'
   },
   {
      label: 'Báo cáo',
      path: '/m-report'
   },
   {
      label: 'Cấu hình SKU',
      path: '/m-sku'
   },
   {
      label: 'Cấu hình vận chuyển',
      path: '/m-shipping'
   },
   {
      label: 'Vận chuyển',
      path: '/m-ship'
   },
   {
      label: 'Whitelist',
      path: '/m-whitelist'
   },
   {
      label: 'Thông báo',
      path: '/m-notification'
   },
   {
      label: 'Dịch vụ',
      path: '/m-service'
   }
]
export const sellerMeta = [
   {
      label: i18n.t(GLOBAL_CLIENT.products),
      path: '/list-products'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.order),
      path: '/m-order'
   },
   {
      label: 'Đơn hàng nháp',
      path: '/m-order-draft',
      type: 'draftOrder'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.transactionHistory),
      path: '/m-transaction-history'
   },
   {
      label: 'Cấu hình Webhook',
      path: '/m-webhook'
   }
]
export const supplierMeta = [
   {
      label: 'Trang chủ',
      path: '/home'
   }
]
export const fulfillmentMeta = [
   {
      label: i18n.t(GLOBAL_CLIENT.products),
      path: '/m-products'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.order),
      path: '/m-order'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.order_scan),
      path: '/m-order-scan'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.warehouse),
      path: '/m-warehouse'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.configOrder),
      path: '/m-config-status'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.transactionHistory),
      path: '/m-transaction-history'
   }
]
export const managerOrderMeta = [
   {
      label: i18n.t(GLOBAL_CLIENT.products),
      path: '/m-products'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.order),
      path: '/m-order'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.warehouse),
      path: '/m-warehouse'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.transactionHistory),
      path: '/m-transaction-history'
   }
]
export const managerStockMeta = [
   {
      label: i18n.t(GLOBAL_CLIENT.mTag),
      path: '/m-tags'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.products),
      path: '/m-products'
   },

   {
      label: i18n.t(GLOBAL_CLIENT.order),
      path: '/m-order'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.warehouse),
      path: '/m-warehouse'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.transactionHistory),
      path: '/m-transaction-history'
   }
]

export const accountantMeta = [
   {
      label: i18n.t(GLOBAL_CLIENT.mFund),
      path: '/m-fund'
   },
   {
      label: i18n.t(GLOBAL_CLIENT.transactionHistory),
      path: '/m-transaction-history'
   }
]

export const supporterMeta = [
   {
      label: 'Trang chủ',
      path: '/home'
   }
]

export const userMeta = [
   {
      label: 'Trang chủ',
      path: '/home'
   }
]

export const ROUTER_PATH = {
   // Admin
   ConfigManagementScreen: 'm-config',
   SellerManagementScreen: 'm-seller',
   FulfillmentManagementScreen: 'm-fulfillment',
   TagManagementScreen: 'm-tags',
   SupplierManagement: 'm-supplier',
   PriceManagement: 'm-price',
   EmployeeManagementScreen: 'm-employee',
   AccountManagementScreen: 'm-account',
   CreateEmployeeScreen: 'm-employee/create',
   ProductsManagement: 'm-products',
   ReportManagement: 'm-report',
   OrderManagement: 'm-order',
   OrderDraftManagement: 'm-order-draft',
   OrderScanManagement: 'm-order-scan',
   WarehouseManagement: 'm-warehouse',
   FundManagement: 'm-fund',
   TransactionHistory: 'm-transaction-history',
   ListProductsManagement: 'list-products',
   ListProductsGroupManagement: 'list-products-group',
   IntroPage: 'home',
   SkuManagementScreen: 'm-sku',
   ShippingManagementScreen: 'm-shipping',
   ShipManagementScreen: 'm-ship',
   ConfigStatus: 'm-config-status',

   WhitelistManagementScreen: 'm-whitelist',
   NotificationManagement: 'm-notification',
   ServiceManagement: 'm-service',
   TwoFactorSetup: 'm-2fa-setup',
   ProfileScreen: 'profiles',
   ResetPassword: 'reset-password',
   PaymentScreen: 'payment',
   WebhookManagementScreen: 'm-webhook'
}
